import { CarTyres } from '@/entities/cars/car-tyres.enum';
import { DateTime } from 'luxon';

export const getCurrentCarTyresSeason = () => {
  const currentMonth = DateTime.now().month;
  return currentMonth >= 4 && currentMonth <= 9 ? CarTyres.SUMMER : CarTyres.WINTER;
};
